import { render, staticRenderFns } from "./SwindonCity.vue?vue&type=template&id=173726a1&scoped=true&"
import script from "./SwindonCity.vue?vue&type=script&lang=js&"
export * from "./SwindonCity.vue?vue&type=script&lang=js&"
import style0 from "./SwindonCity.vue?vue&type=style&index=0&id=173726a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173726a1",
  null
  
)

export default component.exports